<template>
    <input
        :class="[
            'py-2 border-gray-700 rounded-md ',
            'focus:border-gray-700 focus:ring focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-white',
            'dark:border-gray-300 dark:bg-dark-eval-1 dark:text-gray-300 dark:focus:ring-offset-dark-eval-1',
            {
                'px-4': !withIcon,
                'pl-11 pr-10': withIcon,
            },
        ]"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        ref="input"
    />
</template>

<script setup>
import { ref,defineProps,defineEmits } from 'vue'

  defineProps({
    modelValue: String,
    withIcon: {
        type: Boolean,
        default: false,
    }
})

const input = ref(null)

// eslint-disable-next-line no-unused-vars
const emit = defineEmits(['update:modelValue'])
// eslint-disable-next-line no-unused-vars
const focus = () => {
    input.value.focus()
}
</script>
